[
  "AMD",
  "Intel",
  "Dell",
  "HP",
  "Lenovo",
  "Asus",
  "ASUS",
  "Kingston",
  "Corsair",
  "MSI",
  "Gigabyte",
  "Western Digital",
  "WD",
  "Crucial",
  "Samsung",
  "TP-Link",
  "Intelbras",
  "Mikrotik",
  "Ubiquiti",
  "NVIDIA",
  "Seagate",
  "Apple",
  "Huawei",
  "Xiaomi",
  "Logitech",
  "HPE",
  "Supermicro"
]
